import React, {Component} from 'react';

import {Link} from 'react-router-dom';
//import logo from './images/PizzeriaLogo.png';



class NavigationBar extends Component{

    render(){

        return(

             <div>
                 

                <div style={{'textAlign':'left','width':'100%','color':'white','backgroundColor':'black','height':'50%'}}>
                   
                   Pizzeria <span>                                     </span>

                        <Link to="/Home"><img src="/PizzeriaLogo.png" width="50"
                        height="50" className="d-inline-block"/>{''}</Link><span></span>

                        <Link to="/OrderPizza">Order Pizza</Link><span>                      </span>
                        <Link to="/BuildPizza">Build Ur Pizza</Link><span>  </span>
                        
                        
                        <p align="right">
  <button type="button" class="btn btn-warning">
    <span class="glyphicon glyphicon-shopping-cart"></span>Shopping cart
  </button>
</p>
                        

                    

                </div>

            </div>
 
 
        )

    }

}

export default NavigationBar;